import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";  // Import Link from react-router-dom
import "../styles/VideoCarousel.css";

function VideoCarousel() {
    const videos = [
        {
            src: "/videos/Snapinsta.app_video_AQO32RgdwkCgBPPsUEosRGoDr4MqPGoMBgxCV-xYLJiTZYKVRvk7XIrbDYAvM5E__O16Gc4MqCpREKCVhlaOQRRNSoCZItZCEQTHpa83.mp4",
            title: "Karaoke Nights",
            description:
                "Sing your heart out to your favorite tunes in an electrifying atmosphere that redefines karaoke nights.",
            button: "Learn More" ,
            link: "events",
        },
        {
            src: "/videos/Snapinsta.app_video_AQOmCrgFL7zuv3p7gcZ2WpHEckrBKu2XTtye74MBD8-lQqwLAUJpWuAD0fwVmCyq-vAR-3BXJDXFlJE9GVYiWd7ppos3QfcD11AsK8M.mp4",
            title: "Weekend DJs & Dancers",
            description:
                "Experience ultimate weekend vibes with live DJs and professional dancers creating unforgettable moments.",
            button: "Reserve Now",
            link: "reserve",
        },
    ];

    const settings = {
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: true,
    };

    return (
        <div className="video-carousel-container">
            {/* Add Section Title */}
            <div className="carousel-title">
                <h2>Explore Our Events</h2>
                <p>Discover unforgettable moments with our unique events.</p>
            </div>
            <div className="carousel-container">
                <Slider {...settings}>
                    {videos.map((video, index) => (
                        <div key={index} className="video-slide">
                            <div className="video-content">
                                <div className="video-wrapper">
                                    <video
                                        className="background-video"
                                        autoPlay
                                        loop
                                        muted
                                        playsInline
                                        src={video.src}
                                    ></video>
                                </div>
                                <div className="description-wrapper">
                                    <h1 className="video-title">{video.title}</h1>
                                    <p className="video-description">{video.description}</p>
                                    <a href={video.link} className="video-button">
                                        {video.button}
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
}

export default VideoCarousel;
